/**
 * Cart Animations - MakeMyMask
 * Animations fluides pour le panier
 */

(function() {
  'use strict';

  const ANIMATION_DURATION = 400;

  /**
   * Animation de suppression d'un item avec slide out
   */
  function animateItemRemoval(item) {
    if (!item) return Promise.resolve();
    
    return new Promise(resolve => {
      // Empêcher les interactions pendant l'animation
      item.style.pointerEvents = 'none';
      
      // Sauvegarder les dimensions initiales
      const initialHeight = item.offsetHeight;
      const computedStyle = window.getComputedStyle(item);
      const initialPaddingTop = parseFloat(computedStyle.paddingTop);
      const initialPaddingBottom = parseFloat(computedStyle.paddingBottom);
      const initialMarginBottom = parseFloat(computedStyle.marginBottom);
      
      // Appliquer les styles initiaux pour l'animation
      item.style.overflow = 'hidden';
      item.style.maxHeight = initialHeight + 'px';
      item.style.opacity = '1';
      item.style.transform = 'translateX(0)';
      
      // Forcer le reflow pour s'assurer que les styles sont appliqués
      void item.offsetHeight;
      
      // Démarrer l'animation
      requestAnimationFrame(() => {
        item.style.transition = `all ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`;
        item.style.opacity = '0';
        item.style.transform = 'translateX(100%)';
        item.style.maxHeight = '0';
        item.style.paddingTop = '0';
        item.style.paddingBottom = '0';
        item.style.marginBottom = '0';
      });
      
      // Résoudre la promesse après l'animation
      setTimeout(() => {
        resolve();
      }, ANIMATION_DURATION);
    });
  }

  /**
   * Animation d'ajout d'un item
   */
  function animateItemAdded(item) {
    if (!item) return;
    
    item.style.opacity = '0';
    item.style.transform = 'translateY(-10px)';
    
    requestAnimationFrame(() => {
      item.style.transition = `all ${ANIMATION_DURATION}ms ease-out`;
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
    });
  }

  /**
   * Animation de mise à jour de quantité
   */
  function animateQuantityChange(item) {
    if (!item) return;
    
    item.style.transition = 'background-color 300ms ease';
    item.style.backgroundColor = 'rgba(0, 0, 0, 0.03)';
    
    setTimeout(() => {
      item.style.backgroundColor = '';
    }, 300);
  }

  /**
   * Animation de la barre de progression
   */
  function animateProgressBar(percentage, isGoalReached = false) {
    const fill = document.querySelector('.bnz-progress-bar__fill');
    if (!fill) return;
    
    fill.style.transition = 'width 500ms ease-out';
    fill.style.width = `${Math.min(percentage, 100)}%`;
    
    if (isGoalReached) {
      fill.style.animation = 'pulse 600ms ease-out';
      setTimeout(() => {
        fill.style.animation = '';
      }, 600);
    }
  }

  /**
   * Animation du prix total
   */
  function animatePriceUpdate(element) {
    if (!element) return;
    
    element.style.transition = 'transform 200ms ease';
    element.style.transform = 'scale(1.05)';
    
    setTimeout(() => {
      element.style.transform = 'scale(1)';
    }, 200);
  }

  /**
   * Animation d'ouverture du drawer
   */
  function animateDrawerOpen(drawer) {
    if (!drawer) return;
    
    const inner = drawer.querySelector('.side-cart');
    if (inner) {
      inner.style.transform = 'translateX(100%)';
      requestAnimationFrame(() => {
        inner.style.transition = 'transform 300ms ease-out';
        inner.style.transform = 'translateX(0)';
      });
    }
  }

  /**
   * Animation de fermeture du drawer
   */
  function animateDrawerClose(drawer) {
    if (!drawer) return Promise.resolve();
    
    return new Promise(resolve => {
      const inner = drawer.querySelector('.side-cart');
      if (inner) {
        inner.style.transition = 'transform 300ms ease-in';
        inner.style.transform = 'translateX(100%)';
        
        setTimeout(resolve, 300);
      } else {
        resolve();
      }
    });
  }

  /**
   * Effet de secousse pour erreur
   */
  function shakeElement(element) {
    if (!element) return;
    
    element.style.animation = 'shake 400ms ease';
    setTimeout(() => {
      element.style.animation = '';
    }, 400);
  }

  /**
   * Écouteurs d'événements
   */
  function bindEvents() {
    // Animation lors de l'ajout
    document.addEventListener('cart:item-added', (e) => {
      const items = document.querySelectorAll('.cart-product');
      if (items.length > 0) {
        animateItemAdded(items[items.length - 1]);
      }
    });

    // Animation lors du changement de quantité
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-input-product-quantity')) {
        const item = e.target.closest('.cart-product');
        animateQuantityChange(item);
      }
    });

    // Animation lors du clic sur suppression
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.js-product-remove-button');
      if (removeBtn) {
        const item = removeBtn.closest('.cart-product');
        if (item) {
          // L'animation se fait avant la suppression réelle
          item.classList.add('removing');
        }
      }
    });

    // Animation d'ouverture du drawer
    document.addEventListener('cart:drawer-opened', () => {
      const drawer = document.querySelector('#sideCartOverlay');
      animateDrawerOpen(drawer);
    });

    // Mise à jour des animations après refresh
    // Note: La barre de progression est maintenant mise à jour via le refresh HTML du side-cart
    // Le calcul complexe avec les multiples seuils est géré côté Liquid
    document.addEventListener('cart:updated', async () => {
      // Ne pas animer la barre ici - elle sera mise à jour par le refresh du HTML
      // L'animation CSS transition: width 500ms ease-out s'occupera de l'animation
    });
  }

  /**
   * Injecter les styles CSS pour les animations
   */
  function injectStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Animations du panier */
      .cart-product {
        transition: opacity 300ms ease, transform 300ms ease, max-height 300ms ease;
        will-change: transform, opacity, max-height;
      }
      
      .cart-product.removing {
        opacity: 0;
        transform: translateX(100%);
        max-height: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-bottom: 0 !important;
        overflow: hidden;
      }
      
      .cart-product.updating {
        background-color: rgba(0, 0, 0, 0.03);
      }
      
      /* Amélioration de la fluidité de l'animation */
      .side-cart__products {
        overflow: visible;
      }
      
      .side-cart__products .cart-product {
        position: relative;
      }
      
      @keyframes pulse {
        0%, 100% { transform: scaleX(1); }
        50% { transform: scaleX(1.02); }
      }
      
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        20%, 60% { transform: translateX(-5px); }
        40%, 80% { transform: translateX(5px); }
      }
      
      @keyframes itemAdded {
        0% { opacity: 0; transform: translateY(-10px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      
      /* Transition smooth pour le drawer */
      .side-cart {
        transition: transform 300ms ease-out;
      }
      
      /* Animation de la barre de progression */
      .bnz-progress-bar__fill {
        transition: width 500ms ease-out;
      }
      
      /* Animation des prix */
      .cart-product__price,
      .side-cart__button {
        transition: transform 200ms ease;
      }
    `;
    document.head.appendChild(style);
  }

  // Initialisation
  function init() {
    injectStyles();
    bindEvents();
    console.log('✨ Cart Animations initialisé');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export global
  window.CartAnimations = {
    animateItemRemoval,
    animateItemAdded,
    animateQuantityChange,
    animateProgressBar,
    animatePriceUpdate,
    animateDrawerOpen,
    animateDrawerClose,
    shakeElement
  };

})();

